'use client'

import { useQuery } from '@tanstack/react-query'
import {
  get24hMarketCapChangeQuery,
  getAssetCategoriesQuery,
  getFearAndGreedIndexQuery,
} from '@/src/queries/keys/market-trends'
import { Carousel, CarouselContent, CarouselItem } from '../ui/carousel'
import { MarketMovementBadge } from './market-movement-badge'
import { SentimentBadge } from './sentiment-badge'
import { TrendingCategoryBadge } from './trending-category-badge'

export function HeroSection() {
  const { data: fearGreedIndex, isLoading: isLoadingFearGreedIndex } = useQuery(
    getFearAndGreedIndexQuery(),
  )

  const { data: marketCapChange, isLoading: isLoadingMarketCapChange } =
    useQuery(get24hMarketCapChangeQuery())

  const {
    data: categoryWithTop24hMcapGain,
    isLoading: isLoadingCategoryWithTop24hMcapGain,
  } = useQuery({
    ...getAssetCategoriesQuery('market_cap_change_24h_desc'),
    select: (data) => data.results[0],
  })

  return (
    <section className='flex flex-col item-center justify-center pt-12 sm:min-h-48 gap-12 relative select-none'>
      <h1 className='text-center text-primary text-4xl sm:text-5xl font-extralight font-serif'>
        Track and trade <em className='font-italic'>everything</em>.
      </h1>
      <div className='w-screen -ml-page-gutter md:w-auto md:mx-auto'>
        <Carousel
          className='flex flex-row justify-start md:justify-center md:mr-0'
          opts={{
            align: 'start',
            active: true,
            dragFree: true,
            breakpoints: {
              '(min-width: 768px)': { active: false },
            },
          }}
        >
          <CarouselContent className='mx-page-gutter md:mx-0'>
            <CarouselItem className='basis-auto ml-0'>
              <SentimentBadge
                level={fearGreedIndex?.value}
                isLoading={isLoadingFearGreedIndex}
              />
            </CarouselItem>
            <CarouselItem className='basis-auto'>
              <MarketMovementBadge
                percentage={marketCapChange}
                isLoading={isLoadingMarketCapChange}
              />
            </CarouselItem>
            <CarouselItem className='basis-auto'>
              <TrendingCategoryBadge
                category={categoryWithTop24hMcapGain}
                isLoading={isLoadingCategoryWithTop24hMcapGain}
              />
            </CarouselItem>
          </CarouselContent>
        </Carousel>
      </div>
    </section>
  )
}
